const state = {
  items: []
};

const getters = {
  getItems: state => state.items,

  isItemWishlisted: state => product =>
    state.items.find(item => item._id === product._id)
};

const actions = {
  toggleProduct({ commit, getters }, product) {
    getters.isItemWishlisted(product)
      ? commit("removeProduct", product)
      : commit("addProduct", product);
  }
};

const mutations = {
  addProduct(state, product) {
    state.items = [...state.items, product];
  },
  removeProduct(state, product) {
    const index = state.items.findIndex(item => item._id === product._id);
    if (index !== -1) {
      state.items.splice(index, 1);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
